import * as ActionTypes from 'actions/reports'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  reports: [],
  currentReportUrl: '',
  currentReportId: '',
}

// Updates error message to notify about the failed fetches.
export default function getReports(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.REPORTS_GETING_REPORTS:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.REPORTS_RECEIVED_REPORTS:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        reports: action.reports,
      }
    case ActionTypes.SETREPORTURL_RECEIVED_SETREPORTURL:
      return {
        ...state,
        currentReportUrl: action.selectedReport,
        currentReportId: action.selectedReportId,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reports.js